/**
 * Copyright (C) 2026 Jugendstil, SLU - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited. Proprietary and confidential.
 */

/**
 * The initial paint, as a list the components add themselves to.
 *
 * A registry rather than one function that calls each component directly, because the sheet needs
 * to repaint its own contents when it opens and so would have to import the thing that imports
 * it. Nothing here imports a component, so there is no cycle for a bundler to break arbitrarily.
 */
export type Painter = (root: ParentNode) => void;

const painters: Painter[] = [];

export function register(painter: Painter): void {
    painters.push(painter);
}

/**
 * Repaints every registered component inside `root`.
 *
 * Idempotent by contract: delegation covers every later change but not the state a control is
 * already in when it arrives, and the same markup may be painted again after a Turbo swap, after
 * a sheet opens, or when a page asks for it with `wp:paint`.
 */
export function paintAll(root: ParentNode): void {
    painters.forEach((painter) => painter(root));
}

/** Test seam: the registry is module state, and a test that registers must be able to undo it. */
export function reset(): void {
    painters.length = 0;
}
